import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { AuthGate } from "./auth";
import { StoreProvider } from "./store";
import { PublicApproval } from "./PublicApproval";
import { PublicRegister } from "./PublicRegister";
import { PublicEntry } from "./PublicEntry";
import "./styles/styles.css";
import "./styles/screens.css";
import "./styles/app.css";

// 数値入力欄でのマウスホイール誤操作を止める（本城さん要望 2026-08-28）。
// 単価や控除の欄にフォーカスが当たったまま画面をスクロールすると、ブラウザ既定の挙動で
// 値が静かに増減してしまう（▲▼のスピナーは app.css で非表示にしたが、ホイールは別経路）。
// 入力中に気づかず単価が変わるのは支払額に直結するため、フォーカスを外して無効化する。
document.addEventListener(
  "wheel",
  (e) => {
    const el = document.activeElement as HTMLInputElement | null;
    if (el && el.type === "number" && el === e.target) el.blur();
  },
  { passive: true }
);

// 公開ページの出し分け（事務所アプリとは別レンダリング・Store非依存）:
//   ?token=xxx               … ドライバー承認ページ
//   ?register=1[&confirm=t]  … メアド自己収集フォーム（confirm 付きは確認完了処理）
//   ?entry=1                 … 入社・契約解除の届出フォーム（スマホ用・ログイン必須。docs/37）
const params = new URLSearchParams(window.location.search);
const token = params.get("token");
const isRegister = params.get("register") === "1";
const isEntry = params.get("entry") === "1";
const confirmToken = params.get("confirm");

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {token ? (
      <PublicApproval token={token} />
    ) : isRegister ? (
      <PublicRegister confirmToken={confirmToken} />
    ) : isEntry ? (
      // 携帯の届出フォーム。送信＝そのままマスタ登録になったため**ログイン必須**にした
      // （公開のままだと URL を知る人が誰でも従業員を登録できてしまう。docs/37 §2）
      <AuthGate>
        <PublicEntry />
      </AuthGate>
    ) : (
      // 事務所アプリはログイン必須（公開ページは上の分岐で先に返るため影響しない）
      <AuthGate>
        <StoreProvider>
          <App />
        </StoreProvider>
      </AuthGate>
    )}
  </React.StrictMode>
);
